import { IApplicationState } from '../../../../../../../types/types';
import { IChatGroup } from '../../../../../../../rest/effects/chats/group/types';
import { TChatGroupId } from '../../../../../../../types/rest/IRestChatGroup';

export const getChatGroup = (
    state: IApplicationState,
    id: TChatGroupId,
): IChatGroup => {
    return state.chatView.groups?.[id];
}
